<template lang="pug">
div(v-if="show")
  .form-group
    .flex-between
      label.control-label Subsites
      HelpPopover(title="Subsites" :content="this.subsiteHelp")
    div
      DropdownCheckboxes(
        label="Subsites"
        :value="value"
        @input="emitInput"
        :options="subsiteOptions"
        class="block"
      )
</template>

<script>
  import { mapStores, mapState } from 'pinia'
  import { useSubsitesStore } from '@/stores/subsites'
  import { isEmpty } from 'lodash'

  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'
  import HelpPopover from '@/components/shared/help_popover.vue'

  export default {
    setup() {
      const subsiteHelp = `If your newsroomQ platform is set up to feed multiple publications or websites, you can choose which website you will be sending this story to here.

You can choose more than one website to send your story to.`

      return { subsiteHelp }
    },

    components: {
      DropdownCheckboxes,
      HelpPopover
    },

    props: {
      publicationId: {
        type: Number,
        required: true,
      },

      // Array of values from options
      // NOTE: be careful that the values match the options values. Number strings are a common issue.
      value: {
        type: Array,
        default() { return [] }
      }
    },

    computed: {
      ...mapStores(useSubsitesStore),
      ...mapState(useSubsitesStore, ['hasMultiple']),

      subsiteOptions() {
        const { publicationId } = this

        return this.subsitesStore.forPublicationAsObject({ publicationId })
      },

      show() {
        return !isEmpty(this.subsiteOptions) && this.hasMultiple
      }
    },

    async mounted() {
      await this.subsitesStore.fetchOnce()
    },

    methods: {
      emitInput(subsiteTownIds) {
        // For component v-model support
        this.$emit('input', subsiteTownIds);
      }
    }
  }
</script>
